//* STORES *//
// TODO: autocomplete possible values for state, getters, and actions based on given namespace and Vuex store
export const useLanguageStore = () =>
	useStore('language', {
		state: ['webLocale', 'locales', 'detectedWebLocale', 'audioLanguage'],
		getters: [
			'language',
			'country',
			'isTTBLanguage',
			'countryEmoji',
			'locale',
			'activeLocalesList',
			'localeObject',
		],
		actions: [
			'setWebLocale',
			'loadLocales',
			'setLanguageWhenUserDidNot',
			'changeWebLocale',
			'setPersistentWebLocale',
			'setDetectedLanguage',
		],
	});

export const useUserStore = () =>
	useStore('user', {
		state: [
			'accessToken',
			'preferredExperiments',
			'isPremium',
			'jwId',
			'timeZone',
			'isUserFirstVisit',
			'onboardingStatus',

			'isVerificationEmailSent',
			'loginProgress',
			'persistedOverriddenLanguage',
			'jwLoginId',
			'loggedInProviders',
			'lastTimeMobileAppBannerWasClosedTS',
			'lastTimeListsOnboardingWasShownTS',
			'userRole',
			'profileIsComplete',
			'settingsProvider',
			'buyboxFilterTypeOptimistic',

			// NEW EXPERIMENTS STATE
			'_preferredExperiments',
			'activatedExperiments',
			'acquiredExperiments',
			// NEW EXPERIMENTS STATE

			'premiumPurchaseFlowState',
			'hideSeenDislikedTitles',
			'info',
			'discoverySettings',
			// OLD BUYBOX EXPS
			'buyboxExpView',
			'buyboxViewExpTooltipAcknowledged',
			// OLD BUYBOX EXPS
		],
		getters: [
			'buyboxPresentationType',
			'newBuyboxFilterType',
			'newBuyboxTooltipAcknowledged',
			'isLoggedIn',
			'newBuyboxView',
			'isUserOnboarded',
			'displayHomeSportsModule',
			'isHideSeenDislikedTitlesEnabled',
			'consents',
			'strictlyAllConsentsGranted',
			'userSearches',
			'isAdmin',
			'isEditor',
			'isProUser',
			'showFreemium',
			'userRole',
			'profileIsComplete',
			'profileInfo',
			'bestEffortId',
			'userInfo',
			'loggedInNewBuyboxView',
			'showOldTitlePage',
			// NEW EXPERIMENTS GETTERS
			'userExperimentsInfo',
			// NEW EXPERIMENTS GETTERS
			'isFlyoutVisible',
			// User Centrics TCF string for GDPR compliance
			'tcString',
			'hasCancelledPremium',
			'subscriptionInfo',
			'isAccountVerified',

			'settings',
		],
		actions: [
			'setBuyboxPresentationType',
			'setNewBuyboxFilterType',
			'setBuyboxFilterTypeOptimistic',
			'setNewBuyboxTooltipAcknowledged',
			'setPremiumStatus',
			'updateUserPremiumStatus',
			'setPremiumPurchaseFlowState',
			'setTimeZone',
			'setNewBuyboxView',
			'setLastTimeListOnboardingWasShownTS',
			'hideHomeSportsModule',
			'setLoginProgress',
			'hideFlyout',
			'loadInfo',
			'logout',
			'setPermanentAudiencesSubgenres',
			'resetPermanentAudiencesSubgenres',
			'saveConsents',
			'saveSettings',
			'setProfileIsComplete',
			'updateUserVisitStatus',
			'saveSearchTerm',
			'saveVisitedTitleId',
			'setLastTimeMobileAppBannerWasClosedTS',
			'loadSettings',
			'clearSearchHistory',
			'setUserRole',
			'setProfileInfo',

			// NEW EXPERIMENTS ACTIONS
			'registerActivatedExperiment',
			'setAcquiredExperiments',
			'setNewPreferredExperiments',
			'setActivatedExperiments',
			// NEW EXPERIMENTS ACTIONS

			'setIsVerificationEmailSent',
			'saveOnboardingStatus',
			'saveDPSConsents',
			'setUsercentricsDPS',
			'setDiscoverySettings',
			'savePersistedOverriddenLanguage',
			'setLoginProviders',
			'updateUserInfo',
			'deleteAccountPermanently',
			'setHideSeenDislikedTitles',
			'toggleShowOldTitlePage',
			'refreshToken',
			'signInInternally',
			'registerInternally',
			'setPremiumCancellationStatus',

			// OLD BUYBOX EXPS
			'setBuyboxExpView',
			'setBuyboxViewExpTooltipAcknowledged',
			// OLD BUYBOX EXPS
		],
	});

export const useRoutingStore = () =>
	useStore('routing', {
		state: ['activeRoute', 'urlMetadataPromise', 'lastRoute', 'lastActiveListsCollectionType'],
		getters: [
			'urlMetadata',
			'currentPageType',
			'activeCollectionType',
			'lastActiveCollectionType',
			'queryParams',
			'activeDomain',
		],
		actions: ['setLastActiveListsCollectionType', 'fetchUrlMetadata', 'setActiveDomain'],
	});

export const useExperimentStore = () =>
	useStore('experiment', {
		state: ['random', 'newExperiments'],
		getters: [],
		actions: ['setNewExperiments'],
	});

export const useAppStore = () =>
	useStore('app', {
		state: [],
		getters: ['isSeoUser', 'xServeTrack', 'ssrTodaysDate', 'isUsingAdBlocker'],
		actions: ['setSSRTodaysDate', 'setIsUsingAdBlocker'],
	});

export const useConstantStore = () =>
	useStore('constant', {
		state: ['ageCertifications', 'genres', 'upcomingProviders'],
		getters: [
			'titleProviderCount',
			'providers',
			'allProvidersById',
			'allProvidersByShortName',
			'providersById',
			'sportProvidersById',
			'subgenresList',
			'providersByShortName',
			'genresByShortName',
			'preselectedProviders',
			'allProviders',
		],
		actions: ['setUpcomingProviders'],
	});

export const useTitleDetailsStore = () =>
	useStore('titleDetails', {
		state: ['didFetchPromotion'],
		getters: [
			'titleContext',
			'lastVisitedTitleName',
			'lastVisitedTitleId',
			'lastVisitedTitleDetails',
			'providerPromotion',
			'sponsoredAd',
		],
		actions: [
			'setSponsoredRecommendation',
			'setProviderPromotion',
			'setTitleContext',
			'clearTitleContext',
			'setPermanentAudiences',
			'resetPermanentAudiences',
			'setLastVisitedTitleDetails',
		],
	});

export const useSportsStore = () =>
	useStore('sports', {
		state: ['didFetchPromotion', 'sportsPromotions'],
		getters: ['sportsPromotions'],
		actions: ['setSportsPromotions'],
	});

export const useFilterStore = () =>
	useStore('filter', {
		state: [],
		getters: [
			'currentFilters',
			'filters',
			'selectedProvidersType',
			'selectedProvidersByType',
			'selectedProviders',
			'editorial',
			'publicListsFilters',
		],
		actions: ['toggle', 'setFilterValue', 'reset', 'resetFilters', 'setSorting', 'updateRouterState', 'setRange'],
	});

export const useStatisticStore = () =>
	useStore('statistic', {
		state: [],
		getters: ['netflixStatsData'],
		actions: ['setNetflixStatsData'],
	});

export const useMetaStore = () =>
	useStore('meta', {
		state: ['visiblePosters'],
		getters: ['appDirection', 'paginationLevel', 'head'],
		actions: [
			'setPagination',
			'setArticleJsonLD',
			'setAuthorJsonLD',
			'setTitleJsonLD',
			'setPopularPageJsonLD',
			'setNewPageJsonLD',
			'setVisiblePosters',
			'setProfileJsonLD',
			'setJsonLd',
		],
	});

export const useReadyStore = () =>
	useStore('ready', {
		state: ['experimentsLoaded', 'newExperimentsLoaded'],
		getters: [],
		actions: ['setReady'],
	});

export const useFooterStore = () =>
	useStore('footer', {
		state: ['topTitles', 'topArticles'],
		getters: [],
		actions: [],
	});

export const useTrackingStore = () =>
	useStore('tracking', {
		state: ['pagesVisited', 'sessionEnvironment'],
		getters: [],
		actions: ['setSessionEnvironmentByKey', 'setSessionEnvironment', 'setOverridePageState'],
	});

export const useListSortingStore = () =>
	useStore('listSorting', {
		state: [],
		getters: ['selectedItem', 'sortingItems'],
		actions: ['setSorting'],
	});

export const useModalStore = () =>
	useStore('modal', {
		state: [],
		getters: ['isOpen'],
		actions: ['setOpen'],
	});

export const useSponsoredRecommendationsStore = () =>
	useStore('sponsoredRecommendations', {
		state: ['catalogue'],
		getters: [],
		actions: ['setSponsoredAd', 'clearSponsoredAd', 'clearAllSponsoredAds'],
	});

//* UTILITIES *//
import type { ComputedRef } from 'vue';
import type { Prettify } from '@/helpers/types';

import { getVm } from '@/helpers/vm-helper';
import { computed, getCurrentInstance } from 'vue';
import { mapGetters, mapState, mapActions } from 'vuex';

interface StoreProperties<StateKey extends string, GetterKey extends string, ActionKey extends string> {
	state: ReadonlyArray<StateKey>;
	getters: ReadonlyArray<GetterKey>;
	actions: ReadonlyArray<ActionKey>;
}

/*
For the State type, we use computed instead of ref to avoid losing reactivity.
This can happen with how Vuex and the app sometimes updates state (changing country for example.)
*/
type State<StateKey extends string> = Record<StateKey, ComputedRef<any>>;
type Getters<GetterKey extends string> = Record<GetterKey, ComputedRef<any>>;
type Actions<ActionKey extends string> = Record<ActionKey, (...args: any) => Promise<any>>;

export function useStore<StateKey extends string, GetterKey extends string, ActionKey extends string>(
	namespace: string,
	{ state, getters, actions }: StoreProperties<StateKey, GetterKey, ActionKey>
) {
	const { proxy: instance } = getCurrentInstance() ?? { proxy: getVm() };

	const mappedState = mapState(namespace, state as StateKey[]);
	const mappedGetters = mapGetters(namespace, getters as GetterKey[]);
	const mappedActions = mapActions(namespace, actions as ActionKey[]);

	return Object.assign(
		Object.fromEntries(state.map(key => [key, computed(() => mappedState[key].call(instance))])),
		Object.fromEntries(getters.map(key => [key, computed(() => mappedGetters[key].call(instance))])),
		Object.fromEntries(actions.map(key => [key, (...args: any) => mappedActions[key].apply(instance, args)]))
	) as Prettify<State<StateKey> & Getters<GetterKey> & Actions<ActionKey>>;
}
